import * as R from 'ramda';
import styled from 'vue-styled-components';

import { FLEX_CENTER_DIV } from '@styles/common.styled.component';

import AdrielLogo from '../../../public/static/assets/img/logos/new_logo_s.png';

import {
    CUSTOM_LOGO_WHITELABEL_HOSTS,
    CUSTOM_LOGO_WORKSPACES,
} from '@/utils/consts';

export default {
    name: 'Logo',
    props: {
        workspaceId: undefined,
        handleClick: { type: Function, default: R.identity },
    },
    render() {
        const id = String(this.workspaceId);
        const customLogo = this.isWhitelabelUrl
            ? CUSTOM_LOGO_WHITELABEL_HOSTS[window.location.hostname || '']
            : CUSTOM_LOGO_WORKSPACES[id];

        const Logo = () => {
            if (customLogo) {
                return (
                    <img
                        src={customLogo.logo}
                        alt={customLogo.title || customLogo.name}
                    />
                );
            }

            return <img src={AdrielLogo} alt="Adriel Logo" />;
        };

        return (
            <Wrapper
                class="adriel-default-transition"
                onClick={this.handleClick}
            >
                <Logo />
            </Wrapper>
        );
    },
};

const Wrapper = styled(FLEX_CENTER_DIV)`
    width: 40px;
    height: 40px;

    svg {
        fill: var(--color-gray-white);
    }
`;
